import React from "react";
import Pageslayout from "../../Layouts/Pageslayout";
const index = () => {
  return <Pageslayout></Pageslayout>;
};

export default index;
